import { APPLICATION_WRITIG_STEPS } from "../constants";
import { initResume } from "./resume.init";

export const initApplication = (form = {}) => ({
    ...(form || {}),

    _recruitment: form?._recruitment || null,

    writingStep: form?.writingStep || APPLICATION_WRITIG_STEPS.RESUME.value,

    resume: initResume(form?.resume),
    questions: (form?.questions || []).map(initApplication_Question),

    certification: {
        ...(form?.certification || {}),
        employmentType: form?.certification?.employmentType || null,
        jobDescription: form?.certification?.jobDescription || null,
        jobDurationsAt: form?.certification?.jobDurationAts || [null, null],
    },
});

export const initApplication_Question = (form = {}) => ({
    ...(form || {}),

    question: form?.question || {},
    response: form?.response || null,
});
